import TemplateBlock from './TemplateBlock';

export default TemplateBlock;
